import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';

import { MobileMenu, NavBar } from '_app/components';
import { MarketingConsentModal } from '_app/components/modals';
import { MapFilterTabs } from '_app/constants/types';
import { publicIdSelector, userSelector, showNavBarSelector } from '_app/features/session';
import ROUTES from './routes';

const AvailableMapSearchPaths = Object.keys(MapFilterTabs).map((key) => MapFilterTabs[key]);

const Pages = () => {
  const publicId = useSelector(publicIdSelector);
  const user = useSelector(userSelector);
  const showNavBar = useSelector(showNavBarSelector);
  const [toggleMobileMenu, setToggleMobileMenu] = useState(false);

  useEffect(() => {
    if (!showNavBar) {
      setToggleMobileMenu(false);
    }
  }, [showNavBar]);

  return (
    <div className="h-full w-full flex flex-col relative overflow-hidden">
      <NavBar user={user} publicId={publicId} showNavBar={showNavBar} onToggleMenu={() => setToggleMobileMenu(true)} />
      <Switch>
        {ROUTES.map((route, index) => (
          <Route key={index} {...route} />
        ))}
        <Redirect from={`/${publicId}/listing`} to={`/${publicId}/listing/${AvailableMapSearchPaths[0].path}/`} />
        <Redirect to="/not-found" />
      </Switch>
      <MobileMenu user={user} publicId={publicId} visible={toggleMobileMenu} onClose={() => setToggleMobileMenu(false)} />
      <MarketingConsentModal />
    </div>
  );
};

export default Pages;
